// @flow
import React from 'react';
import {makeStyles} from '@material-ui/core';
import CustomButton from '../CustomButton/CustomButton';
import {colors} from '../../assets/styles/colors';

type Props = {
  children: React$Node,
  tab: number,
  selectedTab: number,
  onSelectTab: (id: number) => void,
  disabled?: boolean,
};

const useStyles = makeStyles(theme => ({
  tabButton: {
    borderRadius: '8px',
    color: colors.grey900,
    fontSize: 16,
    fontWeight: 600,
    textTransform: 'none',
    width: 'fit-content',
    [theme.breakpoints.down('md')]: {
      width: '100%',
      flexBasis: '100%',
    },
  },
  active: {
    backgroundColor: '#FFFFFF',
    color: '#7B39FF',
  },
}));

function PageTab({children, tab, selectedTab, onSelectTab, disabled}: Props) {
  const classes = useStyles();
  return (
    <CustomButton
      className={`${classes.tabButton} ${
        selectedTab === tab ? classes.active : ''
      }`}
      onClick={() => onSelectTab(tab)}
      disabled={!!disabled}
    >
      {children}
    </CustomButton>
  );
}

export default PageTab;
